<template lang="html">
  <!-- <v-flex pa-0>    
    <v-flex class="subtitle-2" mt-4>Non-member spouse</v-flex>
    <flv-values :values="nonMemberValues"/>

    <apexcharts
        class="no-print"
      ref="graph_nonmember"
      width="100%"
      :height="250"
      :options="nonMemberChartOptions"
      :series="nonMemberSeries"
    ></apexcharts>

    <v-flex class="subtitle-2" mt-4>Member spouse pension post reduction</v-flex>
    <flv-values :values="memberValues"/>
    <apexcharts
        class="no-print"
      ref="graph_member"
      width="100%"
      :height="250"
      :options="memberChartOptions"
      :series="memberSeries"
    ></apexcharts>

  </v-flex> -->


  <v-row>
    <!-- <v-col cols="12" class=""> -->
    <!-- <v-row> -->
    <FlvSplitPercent
      v-model="splitPercent"
      :total-value="Number(data.flv)"
    />

    <v-col
      cols="12"
      class="text-h6 pb-0"
      mt-4
    >
      Member spouse
    </v-col>
        
    <flv-values :values="memberValues" />

    <v-col
      cols="12"
      class="py-0"
    >
      <apexcharts
        ref="graph_member"
        class="no-print"
        width="100%"
        :height="250"
        :options="memberChartOptions"
        :series="memberSeries"
      />
    </v-col>

    <!-- </v-row> -->
    <!-- </v-col> -->

    <!-- <v-col cols="12" class=""> -->
      
    <v-col
      class="text-h6 pb-0"
      mt-4
    >
      Non-member spouse
    </v-col>

    <flv-values :values="nonMemberValues" />
      
    <v-col
      cols="12"
      class="py-0"
    >
      <apexcharts
        ref="graph_nonmember"
        class="no-print"
        width="100%"
        :height="250"
        :options="nonMemberChartOptions"
        :series="nonMemberSeries"
      />
    </v-col>
    <!-- </v-col> -->
  </v-row>
</template>

<script>
import helpers from '@/mixins/helpers'
import chartOptions from './chart-options'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexcharts: VueApexCharts
  },
  mixins: [ helpers, chartOptions ],
  props: {
    data: Object,
    dynamicData: Object,
  },
  data () {
    return {
      nonMemberSeries: [],
      memberSeries: [],
      xValues: [],
      splitPercent: 0,
    }
  },
  computed: {
    labels () {
      let schemeLabelOverides = {
        pss: {
          separationAmount: 'Separation amount',
        },
      }
      let labels = {
        nonMemberSinglePensionType: {
          nonMemberIndexed: 'Non-member pension',
          nonMemberNonIndexed: '',
        },
        nonMemberSplitPensionType: {
          nonMemberIndexed: 'Non-member pension (indexed)',
          nonMemberNonIndexed: 'Non-member pension (non-indexed)',
        },
        memberSinglePensionType: {
          memberIndexed: 'Member pension - post reduction',
          memberNonIndexed: 'Member pension - post reduction',
        },
        memberSplitPensionType: {
          memberIndexed: 'Member pension (indexed) - post reduction',
          memberNonIndexed: 'Member pension (non-indexed) - post reduction',
        },
        defaults: {
          separationAmount: 'Transfer amount',
          nonMemberTotal: 'Non-member pension',
          memberTotal: 'Member pension'
        }
      }
      return {
        ...labels.defaults, 
        ...(this.nonMemberSplitPensionType ? labels.nonMemberSplitPensionType : labels.nonMemberSinglePensionType),
        ...(this.memberSplitPensionType ? labels.memberSplitPensionType : labels.memberSinglePensionType),
        ...(schemeLabelOverides[this.data.super_type] || {}),
        }
    },
    memberColors () {
      return [ '#068ffb', '#0ee396', '#feb018', '#ff4560', '#765dd0']
    },
    nonMemberColors () {
      return [  '#0ee396','#068ffb', '#feb018', '#ff4560', '#765dd0']
    },
    maxFlvSv () {
      return Math.max(this.data.flv, this.data.sv_nett)
    },
    nonMemberSplitPensionType () {
      let { super_type } = this.data
      return super_type === 'css'
    },
    memberSplitPensionType () {
      let { super_type, valuation_type } = this.data
      return super_type === 'css'
        || (super_type === 'dfrdb' && ['dfrdb_pension_1973', 'dfrdb_associate_1973'].indexOf(valuation_type) > -1)
    },
    memberValues () {
      return {
          primary: [
            { label: this.labels.memberIndexed, value: this._$(this.calcMember({ indexation: 'indexed' }), 0), color: this.memberColors[1] },
            ...( this.memberSplitPensionType 
              ? [{ label: this.labels.memberNonIndexed, value: this._$(this.calcMember({ indexation: 'non_indexed' }), 0), color: this.memberColors[2] }] 
              : []
              )
          ]
        }
    },
    nonMemberValues () {
      return {
        primary: [
          { label: this.labels.nonMemberIndexed, value: this._$(this.calcNonMember({ indexation: 'indexed' }), 0), color: this.nonMemberColors[1] },
          ...( this.nonMemberSplitPensionType 
            ? [{ label: this.labels.nonMemberNonIndexed, value: this._$(this.calcNonMember({ indexation: 'non_indexed' }), 0), color: this.nonMemberColors[2] }] 
            : []
            )
        ],
        secondary: [
          { label: this.labels.separationAmount, value: this._$(this.calcSeparationAmount(), 0)},
        ]
      }
    },
    sharedChartOptions () {
      return {
        legendShow: false,
        stacked: true,
        tooltipEnabledSeries: [1,2,3,4],
        strokeWidth: [1.5, 3, 3, 3],
        strokeDashArray: [5, 0]
        }
    },
    nonMemberChartOptions () {
      return this._chartOptions({
        ...this.sharedChartOptions,
        id: 'nonmember',
        colors: this.nonMemberColors     
      })
    },
    memberChartOptions () {
      return this._chartOptions({
        ...this.sharedChartOptions,
        colors: this.memberColors,  
        id: 'member',
      })
    },
    annualIndexedPension () {
      let { valuation_type, aip, adip, pip, ip, p, pr } = this.data
      switch (valuation_type) {
        case 'css_pension_recipient': return ip
        case 'css_pension_associate': return aip      
        case 'css_pension_associate_defered': return adip
        case 'css_pension_post_std': return pip      
        case 'css_pension_post_all': return pip
        case 'css_pension_post_std_lump_sum': return pip
        case 'css_pension_dup': return 0

        case 'dfrd_pension_1948': return p
        case 'dfrd_associate_1948': return ip
        case 'dfrdb_pension_1973': return ip
        case 'dfrdb_associate_1973': return ip

        case 'msbs_pension': return p
        case 'msbs_pensioner_associate': return p

        case 'pss_pensioner': return pr

        default: return 0
      }
    },
    annualNonIndexedPension () {
      let { valuation_type, anip, nip } = this.data
      switch (valuation_type) {
        case 'css_pension_recipient': return nip
        case 'css_pension_associate': return anip      
        case 'css_pension_associate_defered': return 0
        case 'css_pension_post_std': return nip      
        case 'css_pension_post_all': return 0
        case 'css_pension_post_std_lump_sum': return 0
        case 'css_pension_dup': return 0

        case 'dfrd_pension_1948': return 0
        case 'dfrd_associate_1948': return 0
        case 'dfrdb_pension_1973': return nip
        case 'dfrdb_associate_1973': return nip

        case 'msbs_pension': return 0
        case 'msbs_pensioner_associate': return 0

        case 'pss_pensioner': return 0

        default: return 0
      }
    }
  },
  beforeMount () {
    let labels = []
    let nonMemberIndexedSeries = { name: this.labels.nonMemberIndexed, type: 'area', data: [] }
    let nonMemberNonIndexedSeries = { name: this.labels.nonMemberNonIndexed, type: 'area', data: [] }
    let nonMemberTotalSeries = { name: this.labels.nonMemberTotal, type: 'line', data: [] }

    let memberIndexedSeries = { name: this.labels.memberIndexed, type: 'area', data: [] }
    let memberNonIndexedSeries = { name: this.labels.memberNonIndexed, type: 'area', data: [] }
    let memberTotalSeries = { name: this.labels.memberTotal, type: 'line', data: [] }

    for (let i = 0; i < 101; i++) {
      let splitPercent = i
      let separationAmount = this.calcSeparationAmount(splitPercent)
      let separationFactor = this.calcSeparationFactor(separationAmount)

      let memberIndexed = this.calcMember({separationFactor, indexation: 'indexed'})
      let memberNonIndexed = this.calcMember({separationFactor, indexation: 'non_indexed'})
      let nonMemberIndexed = this.calcNonMember({separationAmount, splitPercent, indexation: 'indexed'})
      let nonMemberNonIndexed = this.calcNonMember({separationAmount, splitPercent, indexation: 'non_indexed'})

      labels.push(splitPercent)

      memberIndexedSeries.data.push(memberIndexed)
      memberNonIndexedSeries.data.push(memberNonIndexed)
      memberTotalSeries.data.push(memberIndexed + (this.memberSplitPensionType ? memberNonIndexed: 0))
      
      nonMemberIndexedSeries.data.push(nonMemberIndexed)
      nonMemberNonIndexedSeries.data.push(nonMemberNonIndexed)
      nonMemberTotalSeries.data.push(nonMemberIndexed + (this.nonMemberSplitPensionType ? nonMemberNonIndexed: 0))
    }
    this.xValues = labels
    this.nonMemberSeries = [ memberTotalSeries, nonMemberIndexedSeries, ...(this.nonMemberSplitPensionType ? [nonMemberNonIndexedSeries] : [])]
    this.memberSeries = [ nonMemberTotalSeries, memberIndexedSeries, ...(this.memberSplitPensionType ? [memberNonIndexedSeries] : [])]
  },
  methods: {
    calcSeparationAmount (splitPercent) {
      if (splitPercent === undefined) splitPercent = this.splitPercent
      return Number((this.maxFlvSv * (splitPercent / 100)).toFixed(0))
    },
    calcSeparationFactor (separationAmount) {
      if (separationAmount === undefined) separationAmount = this.calcSeparationAmount()
      return Math.floor(separationAmount / 100) / Math.floor(this.data.sv_gross / 100)
    },
    calcNonMember (params = {}) {
      let { separationAmount, splitPercent, indexation } = params
      let { super_type, indexed_pension_sv, indexed_pension_flv, non_indexed_pension_sv, non_indexed_pension_flv } = this.data
      let factor, factorId, maxFlvSv

      if (splitPercent === undefined) splitPercent = this.splitPercent
      if (separationAmount === undefined) separationAmount = this.calcSeparationAmount()
      switch (super_type) {
        case 'css': {
          maxFlvSv = indexation === 'indexed' ? Math.max(indexed_pension_flv, indexed_pension_sv) : Math.max(non_indexed_pension_flv, non_indexed_pension_sv)
          factorId = indexation === 'indexed' ? 'factor_SPFy' : 'factor_APFy'
          separationAmount = (maxFlvSv * (splitPercent / 100)).toFixed()
          break
        }
        default: {
          factorId = 'factor_Fy'
          break
        }
      }

      factor = this.data[factorId]

      return factor ? separationAmount / this.data[factorId] : 0
    },
    calcMember (params = {}) {
      let { separationFactor, indexation = 'indexed' } = params
      let rate = indexation === 'indexed' ? this.annualIndexedPension : this.annualNonIndexedPension

      if (separationFactor === undefined) separationFactor = this.calcSeparationFactor()

      return rate ? rate * (1 - separationFactor) : 0
    },
  },
  
}
</script>

<style lang="css">

</style>
